<!-- 论文要求查看 -->
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">{{$getShowName()}}要求查看</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="专业">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="上传人">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="上传时间">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="查看">
                    <template slot-scope="scope">
                      <el-link :underline="false" @click="seeQRCode(scope.$index)" type="primary">查看</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :page-size="limit"
                layout="prev, pager, next"
                :total="count"
                @current-change="pageChange"
            >
            </el-pagination>
        </el-row>

    </div>
</template>
<script>
export default {
  name: "Require",
  data() {
    return {
        count:1,
        tableData: [],
        dialogImageUrl: '',
        dialogVisible: false
    };
  },
  created() {

  },
  methods: {
    seeQRCode(index){
        this.dialogVisible =true;
        this.dialogImageUrl = this.tableData[index].url;
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-Require{
    .wd{
        color: @red;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/pages/dissertation/Require.vue